module.exports = __webpack_public_path__ + "static/media/cross-icon.ed46bb4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/cross-icon.svg
// module id = 2249
// module chunks = 0